export default [
  {
    key: 'online_agent',
    name: '在线代理商个数',
    sortable: true,
    filterable: true,
    type: 'target',
    parent: 'agent_adv',
    minWidth: 180
  },
  {
    key: 'avg_cost_online_agent',
    name: '在线代理商平均消耗(元)',
    sortable: true,
    filterable: true,
    type: 'target',
    parent: 'agent_adv',
    minWidth: 220
  },
  {
    key: 'online_adv',
    name: '在线广告主个数',
    sortable: true,
    filterable: true,
    type: 'target',
    parent: 'agent_adv',
    minWidth: 180
  },
  {
    key: 'avg_cost_online_adv',
    name: '在线广告主平均消耗(元)',
    sortable: true,
    filterable: true,
    type: 'target',
    parent: 'agent_adv',
    minWidth: 220
  }
];
